import { Gruser } from '../../types/papi';
import { AppState, PrivilegesSlice } from '../../types/store';
import { getCurrentGruserSlice } from './grusers';

export const getPrivileges = (
  state: AppState,
  gruser: Gruser | undefined
): PrivilegesSlice | undefined =>
  getCurrentGruserSlice(state, gruser)?.privileges;

export const canAddModule = (state: AppState, gruser: Gruser | undefined) =>
  getPrivileges(state, gruser)?.addModule === true;

export const canMoveModule = (state: AppState, gruser: Gruser | undefined) =>
  getPrivileges(state, gruser)?.moveModule === true;

export const canViewPage = (state: AppState, gruser: Gruser | undefined) =>
  getPrivileges(state, gruser)?.viewPage === true;
